import * as district from 'src/api/district'
import router from 'src/router'
import {
  GET_ALL_DISTRICT,
  GET_DISTRICT_TO,
  GET_DISTRICT_FROM,
  SET_LOADED_DISTRICT_BY_CITY_CODE,
  GET_DISTRICT_KIND,
  SET_LOADED_DISTRICT_BY_CITY_ID,
  GET_DISTRICT
} from 'src/store/mutation-types'

const getAllDistrict = ({commit, dispatch, state}, params) => {
  if (params.city_code && state.districtsByCityCode[params.city_code] && state.districtsByCityCode[params.city_code].length) {
    commit(GET_ALL_DISTRICT, state.districtsByCityCode[params.city_code])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    district.getAllDistrict(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_DISTRICT, response.data)
        if (params.city_code) {
          commit(SET_LOADED_DISTRICT_BY_CITY_CODE, {city_code: params.city_code, districts: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_DISTRICT, [])
      }
    })
  }
}

const getAllDistrictTo = ({commit, dispatch, state}, params) => {
  if (params.city_code && state.districtsByCityCode[params.city_code] && state.districtsByCityCode[params.city_code].length) {
    commit(GET_DISTRICT_TO, state.districtsByCityCode[params.city_code])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    district.getAllDistrict(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_DISTRICT_TO, response.data)
        if (params.city_code) {
          commit(SET_LOADED_DISTRICT_BY_CITY_CODE, {city_code: params.city_code, districts: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_DISTRICT_TO, [])
      }
    })
  }
}

const getAllDistrictFrom = ({commit, dispatch, state}, params) => {
  if (params.city_code && state.districtsByCityCode[params.city_code] && state.districtsByCityCode[params.city_code].length) {
    commit(GET_DISTRICT_FROM, state.districtsByCityCode[params.city_code])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    district.getAllDistrict(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_DISTRICT_FROM, response.data)
        if (params.city_code) {
          commit(SET_LOADED_DISTRICT_BY_CITY_CODE, {city_code: params.city_code, districts: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_DISTRICT_FROM, [])
      }
    })
  }
}

const getDistrictKind = ({commit, dispatch}, params = {}) => {
  dispatch('toggleLoadding', true, {root: true})
  district.getDistrictKind().then(response => {
    dispatch('toggleLoadding', false, {root: true})
    commit(GET_DISTRICT_KIND, response.kinds)
  })
}

const getDistrictByCityId = ({commit, dispatch, state}, params = {}) => {
  if (params.city_id && state.districtsByCityId[params.city_id] && state.districtsByCityId[params.city_id].length) {
    commit(GET_ALL_DISTRICT, state.districtsByCityId[params.city_id])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    district.getAllDistrict(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_DISTRICT, response.data)
        if (params.city_id) {
          commit(SET_LOADED_DISTRICT_BY_CITY_ID, {city_id: params.city_id, districts: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_DISTRICT, [])
      }
    })
  }
}

const getDistrict = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  district.getDistrict(configs.id, configs.params).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_DISTRICT, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Quận huyện không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'district'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setDistrict = ({commit}, district) => {
  commit(GET_DISTRICT, district)
}

export default{
  getAllDistrict,
  getAllDistrictTo,
  getAllDistrictFrom,
  getDistrictKind,
  getDistrictByCityId,
  getDistrict,
  setDistrict
}



// WEBPACK FOOTER //
// ./src/components/district/store/actions.js